import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const QuizWrapper = styled.div`
    background-color: ${colors.brandMid};
    padding-bottom: 50px;

    ${breakpoints.large} {
        padding-bottom: 0;
    }

    .assesment-outer [class*="AnimateAutoHeight"] {
        overflow: visible;
    }
    .assesment-outer [class*="region_results"] {
        position: absolute;
        left:0;
        top:70px;
        width: 100%;
    }
`;

/**
 * This component removes the offset applied by NavWrapper, then reapplies it to the first child
 * Used because when we wrap the AssessmentContent with our animations, it throws off where
 * the navs offset is supposed to be applied
 */
export const NavOffsetFix = styled.div`
    margin-top: calc(var(--nav-height) * -1);

    > *:first-child {
        position: relative;

        &::before {
            position: relative;
            display: block;
            content: "";
            height: var(--nav-height);
        }
    }
`;
